import React, { useEffect } from 'react';
import { useRequirementsAndPayContext } from '../../context';
import { Colors, Text } from 'library';
import { styled } from '@mui/material';
import { GenericChoice, Qualification } from '../../types';
import { experienceChoice, singleChoice } from '../../utils/choices';
import SingleSelect from '../../../BusinessJobRequirementsPage/SingleSelect';
import { NORTH_CAROLINA_ROLE_ID } from '../../constants';
import { updateScale } from '../../utils/scale';

const LEAD_TEACHER = 'Lead Teacher';
const ASSISTANT_TEACHER = 'Assistant Teacher';

export function NorthCarolinaRequirements({
    update,
}: {
    update: (
        value: number | number[],
        choices: GenericChoice[],
        qualification: Qualification | null,
        category: 'education' | 'experience' | 'multiple' | 'single' | 'boolean',
    ) => void;
}) {
    const { initialScale, qualifications, updateScales } = useRequirementsAndPayContext();
    const ncRoleQualification = qualifications.single.find(
        (singleQualification: { qualification: Qualification; choices: GenericChoice[] }) =>
            singleQualification.qualification.id === NORTH_CAROLINA_ROLE_ID,
    );

    useEffect(() => {
        let updatedScale = initialScale;
        if (ncRoleQualification && selected !== LEAD_TEACHER) {
            updatedScale = updateScale(
                updatedScale,
                ncRoleQualification.choices[0].key,
                ncRoleQualification.choices,
                ncRoleQualification.qualification,
                'single',
            );
        }
        if (qualifications.experience) {
            const choice = experienceChoice(initialScale, qualifications.experience);
            if (!choice || choice !== 1) return;
            updatedScale = updateScale(
                updatedScale,
                qualifications.experience[0].key,
                qualifications.experience,
                null,
                'experience',
            );
        }
        updateScales(updatedScale);
    }, []);

    const selected = ncRoleQualification?.qualification.options.find(
        (option) =>
            option.id == singleChoice(initialScale, ncRoleQualification.qualification, ncRoleQualification.choices),
    )?.value;

    function onChange(val: string | undefined) {
        if (!ncRoleQualification) return;

        update(
            ncRoleQualification.choices.find((choice) => choice.value === val)?.key ?? 0,
            ncRoleQualification.choices,
            ncRoleQualification.qualification,
            'single',
        );
    }

    return ncRoleQualification ? (
        <Question>
            <div>
                <Text bold>What type of role are you hiring for?</Text>
                <Text variant="caption">
                    Note: All Tandem teachers must meet the minimum requirements for to be an assistant teacher.
                    Limiting to the lead teacher role will reduce the number of qualified candidates.
                </Text>
                <SingleSelect
                    onChange={onChange}
                    value={selected ?? ASSISTANT_TEACHER}
                    options={ncRoleQualification.qualification.options}
                />
            </div>
        </Question>
    ) : null;
}

const Question = styled('div')(({ error }: { error?: string }) => ({
    alignItems: 'center',
    backgroundColor: error === 'true' ? '#fff5f5' : Colors.white,
    borderRadius: 10,
    border: error === 'true' ? `1px solid ${Colors.error}` : 'none',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '5px 20px',
}));
